<template>
  <div style="width:100%;float:left;">
    <CCard>
      <CCardHeader>
        <CIcon name="cil-calendar"/> Calendar
        <div class="card-header-actions">
          
        </div>
      </CCardHeader>
      <CCardBody>
        <div style="width:100%;float:left;text-align:center;">
          <h5 style="font-size: 11px;color:grey;">Click to show or hide certain dates...</h5>
          <CButton size="sm" :color="calendar_ship_dates ? 'info' : 'outline-info'" @click="showClicked('calendar_ship_dates')">Ship Dates</CButton>
          <CButton size="sm" class="ml-2" :color="calendar_event_dates ? 'warning' : 'outline-warning'" @click="showClicked('calendar_event_dates')">Event Dates</CButton>
          <CButton size="sm" class="ml-2" :color="show_holidays ? 'success' : 'outline-success'" @click="showClicked('show_holidays')">Holidays</CButton>
        </div>
        <spacer />
        <div style="width:100%;float:left;text-align:center;">
          <calendar-view
            v-if="events"
            id="calendar"
            :events="events"
            enable-drag-drop
            :show-date="showDate"
            :displayPeriodUom="displayPeriod"
            currentPeriodLabel="icons"
            :class="themeClasses"
            @click-date="onClickDay"
            @click-event="onClickEvent"
            @drop-on-date="onDrop"
            @show-date-change="setShowDate"
            ref="calendarView"
          >
            <calendar-view-header
    					slot="header"
    					slot-scope="{ headerProps }"
    					:header-props="headerProps"
    					@input="setShowDate"
    				/>
          </calendar-view>
        </div>
      </CCardBody>
      <CCardFooter>
        <CForm inline>
          <CSelect
            :options="['year', 'month', 'week']"
            :value.sync="displayPeriod"
            label="View"
            add-wrapper-classes="ml-2"
          />
          <h4 class="ml-auto my-auto">
            <CBadge v-if="message" color="primary">{{ message }}</CBadge>
          </h4>
        </CForm>
      </CCardFooter>
    </CCard>

    <CModal
      title="Modal title"
      size="lg"
      :show.sync="modalShow"
    >
      <template #header>
        <h6 class="modal-title" v-if="modalData">{{modalData.startDate}}</h6>
        <CButtonClose @click="modalShow = false, modalData = null" class="text-black"/>
      </template>
      <div v-if="modalData" style="width:100%;float:left;overflow-x:scroll;">
        <h5 style="width:100%;float:left;text-align: center;">Click on row to view order.</h5>
        <table class="table" v-if="modalData">
          <thead>
            <tr>
              <th>Order#</th>
              <th>Customer</th>
              <th>Program</th>
              <th>PO</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="val in modalData.items" @click="goToOrder(val)">
              <td>{{val.order_id}}</td>
              <td>{{val.customer_number}}</td>
              <td>{{val.program_name}}</td>
              <td>{{val.po_number}}</td>
              <td>{{val.status}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <!-- <CButton @click="showModal = false" color="danger">Discard</CButton> -->
        <CButton @click="modalShow = false, modalData = null" color="secondary">Close</CButton>
      </template>
    </CModal>

    <CModal
        title="Order"
        :show.sync="orderModal"
        size="lg"
      >
      <div style="width:100%;float:left;" v-if="currentOrderId">
        <div style="width:100%;float:left;text-align:center;margin-bottom:15px;">
          <CButton size="sm" color="info" @click="goToOrderPage()">Go To Order Page</CButton>
        </div>
        <order-wrapper :order_id="currentOrderId"></order-wrapper>
      </div>
    </CModal>

    <CModal
        :title="currentHolidayDate + ' Date Clicked'"
        :show.sync="dateModal"
        size="lg"
      >
      <div style="width:100%;float:left;" v-if="dateModal">
        <div style="width:100%;float:left;text-align: center;">
          <input placeholder="Holiday Name.." class="form-control" type="text" v-model="holidayName" />

          <CButton size="sm" :disabled="!holidayName" class="mt-2" color="success" @click="submitHoliday()">Submit New Holiday</CButton>
        </div>
        <spacer />
        <div style="width:100%;float:left;" v-if="holidays && holidays.length">
          <table class="table">
            <thead>
              <tr>
                <th style="text-align:center;">Holidays</th>
                <th style="text-align:center;"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(val, index) in holidays">
                <td style="text-align:center;">{{val.name}}</td>
                <td style="text-align:center;">
                  <CButton size="sm" color="danger" @click="removeHoliday(val, index)">Remove</CButton>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <template #footer>
        <CButton @click="dateModal = false" color="secondary">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
  import OrderWrapper from './../orders/order_wrapper'
  import { 
    CalendarView, 
    CalendarViewHeader, 
    CalendarMathMixin 
  } from 'vue-simple-calendar'
  // import CalendarMathMixin from 'vue-simple-calendar/dist/calendar-math-mixin.js'
  // The next two lines are processed by webpack. If you're using the component without webpack compilation,
  // you should just create <link> elements for these as you would normally for CSS files. Both of these
  // CSS files are optional, you can create your own theme if you prefer.
  import 'vue-simple-calendar/static/css/default.css'
  import 'vue-simple-calendar/static/css/holidays-us.css'
  var methods = {}

  const currDate = new Date();
  const currYear = currDate.getFullYear();
  const currMonth = currDate.getMonth();

methods.goToOrder = function (val) {
  // this.$router.push('/order/' + val.order_id)
  this.currentOrderId = val.order_id
  this.modalShow = false
  this.orderModal = true
}

methods.showClicked = function (type) {
  this[type] = !this[type]
  window.localStorage.setItem(type, this[type])
  this.filterData()
}

methods.goToOrderPage = function (val) {
  this.$router.push('/order/' + this.currentOrderId)
}

methods.getData = function (date) {
  // var date = moment(currDate.toString()).format("YYYY-MM-DD")
  const postData = {
    date: date,
    month: currMonth,
    year: currYear
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/getCalendar?token=' + localStorage.getItem('api_token'), postData).then(res => {
    console.log(res)
    
    this.data = res.data.res
    this.holidayData = res.data.holidays
    this.filterData()
    
  }).catch(e => {
    console.log(e)
  })
}

methods.submitHoliday = function () {
  const postData = {
    date: this.currentHolidayDate,
    name: this.holidayName
  }
  axios.post(this.$apiAdress + '/api/submitHoliday?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    // this.dateModal = false
    this.holidayName = ''
    this.holidays.push(response.data)
    // this.currentHolidayDate = ''
  })
}

methods.removeHoliday = function (holiday, index) {
  const postData = {
    holiday: holiday
  }
  axios.post(this.$apiAdress + '/api/removeHoliday?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    // this.dateModal = false
    this.holidays.splice(index, 1)
    // this.currentHolidayDate = ''
  })
}

methods.filterData = function () {
  var arr = []
  var o = {}
  var eventObj = {}
  var that = this
  this.data.forEach(function (val) {
    if (that.calendar_ship_dates) {
      if (!o[val.ship_date]) {
        o[val.ship_date] = {
          title: '',
          total: 0,
          startDate: val.ship_date,
          endDate: val.ship_date,
          classes: 'primary',
          items: []
        }
      }
      o[val.ship_date].total += 1
      o[val.ship_date].items.push(val)
    }

    if (that.calendar_event_dates) {
      if (val.event_date) {
        if (!eventObj[val.event_date]) {
          eventObj[val.event_date] = {
            title: '',
            total: 0,
            startDate: val.event_date,
            endDate: val.event_date,
            classes: 'orange',
            items: []
          }
        }
        eventObj[val.event_date].total += 1
        eventObj[val.event_date].items.push(val)
      }
    }
    
  })

  for (var key in o) {
    o[key].title = o[key].total + ' Items'

    arr.push(o[key])
  }
  for (var key in eventObj) {
    eventObj[key].title = eventObj[key].total + ' Items'

    arr.push(eventObj[key])
  }

  var hObject = {}

  if (this.show_holidays) {
    this.holidayData.forEach(function (val) {
      if (!hObject[val.date]) {
        hObject[val.date] = true
        var hObj = {
          title: val.name,
          total: '',
          startDate: val.date,
          endDate: val.date,
          classes: 'success',
          items: []
        }
        arr.push(hObj)
      }
    })
  }

  this.events = arr
}

methods.setShowDate = function (d) {
  var date = moment(d).format('YYYY-MM-DD')
  console.log(date)
  this.getData(d)
  this.showDate = d;
}

methods.getHolidays = function (date) {
  this.currentHolidayDate = date
  const postData = {
    date: date
  }
  axios.post(this.$apiAdress + '/api/getHolidaysByDate?token=' + localStorage.getItem('api_token'), postData).then(response => {
    this.holidays = response.data
  })
}

methods.onClickDay = function (d) {
  console.log(d.toISOString().split('T')[0])
  this.message = `You clicked: ${d.toLocaleDateString()}`
  if (this.dateClicked === d.toLocaleDateString()) {
    // this.dateClicked = d.toLocaleDateString()
    this.getHolidays(d.toISOString().split('T')[0])
    this.dateModal = true
  } else {
    this.dateClicked = d.toLocaleDateString()
  }
}

methods.onClickEvent = function (e) {
  console.log(e)
  this.modalData = e.originalEvent
  this.modalShow = true
  // this.message = `You clicked: ${e.title}`
}

methods.onDrop = function (event, date) {
  // this.message = `Moved: ${event.title || event.id} to ${date.toLocaleDateString()}`
  // // Determine the delta between the old start date and the date chosen,
  // // and apply that delta to both the start and end date to move the event.
  // const eLength = this.dayDiff(event.startDate, date)
  // event.originalEvent.startDate = this.addDays(event.startDate, eLength)
  // event.originalEvent.endDate = this.addDays(event.endDate, eLength)
}

  export default {
    name: 'Calendar',
    mixins: [CalendarMathMixin],
    data: function () {
      return {
        message: '',
        showDate: currDate,
        displayPeriod: 'month',
        // events: sampleEvents,
        useDefaultTheme: true,
        useHolidayTheme: true,
        events: [],
        modalShow: false,
        modalData: null,
        currentOrderId: null,
        orderModal: false,
        calendar_ship_dates: false,
        calendar_event_dates: false,
        dateModal: false,
        dateClicked: '',
        holidays: null,
        currentHolidayDate: '',
        holidayName: '',
        holidayData: null,
        show_holidays: true
      }
    },
    components: {
      CalendarView,
      CalendarViewHeader,
      OrderWrapper
    },
    mounted: function () {
      var arr = ['calendar_event_dates', 'calendar_ship_dates', 'show_holidays']
      var that = this
      arr.forEach(function (val) {
        var a = window.localStorage.getItem(val)
        if (a) {
          that[val] = a
        }
      })
      this.getData(moment().format('YYYY-MM-DD'))
    },
    computed: {
      themeClasses() {
        return {
          'theme-default': this.useDefaultTheme,
          'holiday-us-traditional': this.useHolidayTheme,
          'holiday-us-official': this.useHolidayTheme,
        }
      }
    },
    methods: methods,
  }
</script>

<style lang="scss">
  @import '../../assets/scss/style';
  #calendar {
    color: $body-color;
    height: 63vh;
    margin-left: auto;
    margin-right: auto;
  }
  .theme-default .cv-event {
    background-color: #C8CED3;
    border-color: $table-border-color;
    color: $body-color;
  }
  .theme-default .cv-event.success {
    background-color: $success;
    border-color: lighten($success, 5%);
  }
  .theme-default .cv-event.danger {
    background-color: $danger;
  }
  .theme-default .cv-event.primary {
    background-color: #20A8D8;
  }
  .theme-default .cv-event.orange {
    background-color: #F8CB00;
    border-color: lighten(#F8CB00, 5%);
  }
  .theme-default .cv-day.today {
    background-color: $gray-300;
  }
  .theme-default .cv-day.today > .cv-day-number {
    background-color: #20A8D8;
    border-radius: 50%;
    position: absolute;
    left: 0;
  }
  .theme-default .cv-day.past {
     background-color: $body-bg;
  }
  .theme-default .cv-day.outsideOfMonth {
     background-color: $body-bg;
  }
  .theme-default .cv-weeks,
  .theme-default .cv-day {
    border-color: $table-border-color;
  }
  .theme-default .cv-header,
  .theme-default .cv-header-days,
  .theme-default .cv-header-day {
    background-color: #E4E5E6;
    border-color: $table-border-color;
    border-style: solid;
  }
  .theme-default .cv-header-nav > button {
    color: $body-color;
    background-color: $input-bg;
    border-color: $input-border-color;
  }
  .theme-default .cv-day.draghover {
    box-shadow: inset 0 0 0.2em 0.2em #321FDB;
  }
</style>
